import { GraphQLObjectType, GraphQLString, GraphQLList, GraphQLBoolean } from 'graphql';
import CardQuestionOptionType from './cardQuestionOptionType.gql';

const cardQuestionType = new GraphQLObjectType({
  name: 'CardQuestion',
  fields: () => ({
    q: {
      type: GraphQLString,
      resolve: item => item.q
    },
    rType: {
      type: GraphQLString,
      resolve: item => item.rType
    },
    rTypeSecondary: {
      type: new GraphQLList(GraphQLString),
      resolve: (item) => {
        const rTypeArray = [];
        item.rTypeSecondary.forEach((rTypeObject, index) => {
          rTypeArray[index] = rTypeObject.value;
        });
        return rTypeArray;
      }
    },
    options: {
      type: new GraphQLList(CardQuestionOptionType),
      resolve: item => item.options.slice()
    }
  })
});

const contentType = new GraphQLObjectType({
  name: 'ResourceContent',
  fields: () => ({
    url: {
      type: GraphQLString,
      resolve: root => root.mediaURL
    },
    downloadUrl: {
      type: GraphQLString
    },
    subtitle: {
      type: GraphQLString
    },
    zoomable: {
      type: GraphQLBoolean
    },
    data: {
      type: GraphQLString,
      resolve: root => root.contentHTML
    },
    thumbUrl: {
      type: GraphQLString,
      resolve: root => root.thumbnail
    },
    questions: {
      type: new GraphQLList(cardQuestionType),
      resolve: () => []
    }
  })
});

const resourceType = new GraphQLObjectType({
  name: 'Resource',
  fields: () => ({
    type: {
      type: GraphQLString,
      resolve: item => item.content.subType
    },
    content: {
      type: contentType,
      resolve: item => item.content
    },
    webThumbUrl: {
      type: GraphQLString,
      resolve: item => item.content.webThumbUrl
    },
    narrationUrl: {
      type: GraphQLString,
      resolve: item => item.content.narrationUrl
    }
  })
});

window[resourceType.name + 'GQLType'] = resourceType;

export default resourceType;
